<div class="container" id="spinerLoader" *ngIf="loader">
    <div class="loader">Loading...</div>
</div>

<div mat-dialog-title class="modal-header">
    <div class="d-flex justify-content-between">
        <span class="ml-3">{{dialogData.header}}</span>
        <button type="button" class="close close-btn" mat-dialog-close><i class="fa fa-close fa-md"></i></button>
    </div>
</div>
<mat-dialog-content>
    <div class="row">
        <div class="col-xs-12">
            <div class="card-layout">
                <form #legAssignmentForm="ngForm">
                    <div class="row">
                        <div class="col-md-6 form-group" *ngIf="!isForRejection">
                            <label>Select Contact Person<span class="text-danger"> * </span>
                                <span *ngIf="memberLoader == true" class="ml-2">
                                    <i class="fa fa-spin fa-spinner text-danger"></i>
                                </span>
                            </label>
                            <ngx-select-dropdown tabindex="0" name="select_person" #select_person="ngModel"
                                [multiple]="false" id="select_person" [(ngModel)]="selectedMember"
                                [config]="contactConfig" [options]="vendorMemberList"
                                [ngClass]="{ 'is-invalid': legAssignmentForm.submitted && select_person.invalid }"
                                (ngModelChange)="getPhoneNumberByMemberId(selectedMember?.memberId)" required>
                            </ngx-select-dropdown>
                            <div *ngIf="legAssignmentForm.submitted && select_person.invalid" class="invalid-feedback">
                                <div *ngIf="select_person.errors.required"><span style="color: red;">
                                        Please Select Contact Person.</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 form-group" *ngIf="!isForRejection">
                            <label>Phone<span class="text-danger"> * </span>
                                <span *ngIf="phoneNumberLoader == true" class="ml-2">
                                    <i class="fa fa-spin fa-spinner text-danger"></i>
                                </span>
                            </label>
                            <input type="text" class="form-control" [value]="selectedPhoneNumber | phoneNumberPipe"
                                disabled>
                        </div>
                        <div class="col-md-12 form-group p-0" *ngIf="!isForRejection">
                            <div class="col-md-6">
                                <label>
                                    {{dialogData.legDetailList[0]?.transportType=='Air' ? 'Select Aircraft' : 'Select Vehicle'}}<span class="text-danger"> *
                                    </span>
                                    <span *ngIf="vehicleLoader == true" class="ml-2">
                                        <i class="fa fa-spin fa-spinner text-danger"></i>
                                    </span>
                                </label>
                                <select id="vehicleId" name="vehicle" #vehicle="ngModel" class="form-control"
                                    [ngClass]="{ 'is-invalid': legAssignmentForm.submitted && vehicle.invalid }"
                                    required [(ngModel)]="assignLegPayload.vehicleId"
                                    (ngModelChange)="selectVehicle($event)">
                                    <option [value]="''" selected disabled>
                                        {{dialogData.legDetailList[0]?.transportType==='Air' ? 'Select Aircraft': 'Select Vehicle'}}
                                    </option>
                                    <option *ngFor="let vehicle of vehicleDetailList" [value]="vehicle.vehicleId">
                                        {{vehicle.vehicleName}}
                                    </option>
                                </select>
                                <div *ngIf="legAssignmentForm.submitted && vehicle.invalid" class="invalid-feedback">
                                    <div *ngIf="vehicle.errors.required"><span style="color: red;">
                                            {{dialogData.legDetailList[0].transportType=='Air'?
                                            "Please Select Aircraft":"Please Select Vehicle"}}</span>
                                    </div>
                                </div>
                                <div *ngIf="legAssignmentForm.submitted && (assignLegPayload.vehicleId=='0')"
                                    class="invalid-feedback">
                                    <span style="color: red;">Please Select Aircraft.</span>
                                </div>
                            </div>

                            <div class="col-md-6" *ngIf="!isForRejection">
                                <label>{{dialogData.legDetailList[0]?.transportType==='Air' ? '#Tail Number': 'Plate Number'}}<span class="text-danger"> * </span></label>
                                <input type="text" disabled [value]="assignLegPayload.vehicleNumber"
                                    class="form-control">
                            </div>

                            <div class="col-md-12 form-group p-0">
                                <div class="col-md-6">
                                    <label>OB Repo</label>
                                    <ng-multiselect-dropdown-angular7 id="outbound_reposition" name="outboundReposition"
                                        [placeholder]="'Select OB Repo'" [settings]="airportCodeDropDownSettings"
                                        [data]="airportCodeList" [(ngModel)]="selectedOBReposition">
                                    </ng-multiselect-dropdown-angular7>
                                </div>
                                <div class="col-md-6">
                                    <label>IB Repo</label>
                                    <ng-multiselect-dropdown-angular7 id="inbound_reposition" name="inboundReposition"
                                        [placeholder]="'Select IB Repo'" [settings]="airportCodeDropDownSettings"
                                        [data]="airportCodeList" [(ngModel)]="selectedIBReposition">
                                    </ng-multiselect-dropdown-angular7>
                                </div>
                            </div>

                            <div class="col-md-12 form-group p-0">
                                <div class="col-md-3">
                                    <label>OB Est. Block Hours</label>
                                    <input type="number" appIntegerOnly id="ob_estimated_block_hours"
                                        name="obEstimatedBlockHours" placeholder="OutBound Estimated Block Hours"
                                        class="form-control" [(ngModel)]="assignLegPayload.obEstimatedBlockHours">
                                </div>
                                <div class="col-md-3">
                                    <label>OB Est. Block Minutes</label>
                                    <input type="number" appIntegerOnly id="ob_estimated_block_minutes"
                                        name="obEstimatedBlockMinutes" #obRepoEstBlockMinutes="ngModel"
                                        placeholder="OutBound Estimated Block Minutes" class="form-control"
                                        [(ngModel)]="assignLegPayload.obEstimatedBlockMinutes"
                                        [ngClass]="{ 'is-invalid': legAssignmentForm.submitted && (assignLegPayload.obEstimatedBlockMinutes > 59) }"
                                        required>
                                    <span
                                        *ngIf="legAssignmentForm.submitted && (assignLegPayload.obEstimatedBlockMinutes > 59)"
                                        class="text-danger">
                                        Please input valid OB Est. Block Minutes
                                    </span>
                                </div>
                                <div class="col-md-3">
                                    <label>IB Est. Block Hours</label>
                                    <input type="number" appIntegerOnly id="ib_estimated_block_hours"
                                        name="ibEstimatedBlockHours" placeholder="InBound Estimated Block Hours"
                                        class="form-control" [(ngModel)]="assignLegPayload.ibEstimatedBlockHours">
                                </div>
                                <div class="col-md-3">
                                    <label>IB Est. Block Minutes</label>
                                    <input type="number" appIntegerOnly id="ib_estimated_block_minutes"
                                        name="ibEstimatedBlockMinutes" #ibRepoEstBlockMinutes="ngModel"
                                        placeholder="InBound Estimated Block Minutes" class="form-control"
                                        [ngClass]="{ 'is-invalid': legAssignmentForm.submitted && (assignLegPayload.ibEstimatedBlockMinutes > 59) }"
                                        [(ngModel)]="assignLegPayload.ibEstimatedBlockMinutes" required>
                                    <span
                                        *ngIf="legAssignmentForm.submitted && (assignLegPayload.ibEstimatedBlockMinutes > 59)"
                                        class="text-danger">
                                        Please input valid OB Est. Block Minutes
                                    </span>
                                </div>
                            </div>

                        </div>
                        <ng-container *ngFor="let detail of dialogData.legDetailList">
                            <div class="col-md-6 form-group">
                                <label>Origin</label>
                                <input type="text" id="enq_origin" [value]="detail.origin" name="origin"
                                    class="form-control" readonly>
                            </div>
                            <div class="col-md-6 form-group">
                                <label>Destination</label>
                                <input type="text" id="enq_destination" [value]="detail.destination" name="destination"
                                    class="form-control" readonly>
                            </div>
                            <div class="col-md-6 form-group">
                                <label>Pickup Time</label>
                                <div class="datetimepicker endtimeDate">
                                    <input type="text" id="startAssigntime" name="startAssigntime" class="form-control"
                                        [value]="detail.plannedPickUpDateTime|localDate" autocomplete="off" disabled />
                                    <i class="fa fa-calendar  calendar-icon"></i>
                                </div>
                            </div>
                            <div class="col-md-6 form-group">
                                <label>Dropoff Time</label>
                                <div class="datetimepicker endtimeDate">
                                    <input type="text" id="endVendortime" name="endVendortime" class="form-control"
                                        [value]="detail.plannedDropOffDateTime|localDate" autocomplete="off" disabled />
                                    <i class="fa fa-calendar  calendar-icon"></i>
                                </div>
                            </div>
                        </ng-container>
                        <div class="col-md-12 form-group" *ngIf="isForRejection">
                            <label>Reason For Rejection <span class="text-danger">*</span></label>
                            <div>
                                <textarea id="rejectionNote" name="rejectionNote" #rejectionNote="ngModel"
                                    class="form-control" [(ngModel)]="rejectionReason" autocomplete="off" rows="2"
                                    required></textarea>
                                <div *ngIf="legAssignmentForm.submitted && rejectionNote.invalid"
                                    class="invalid-feedback">
                                    <div *ngIf="rejectionNote.errors.required">
                                        <span style="color: red;">
                                            Please write down the reason for rejection!
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer pr-0 pb-0">
                        <button type="button" class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10"
                            mat-dialog-close>Cancel</button>
                        <button type="submit" class="flat-butt flat-info-butt flat-info-grad-butt save-btn"
                            *ngIf="!isForRejection" (click)="assignDriver(legAssignmentForm)">Assign</button>
                        <button type="submit" class="flat-butt flat-info-butt flat-info-grad-butt save-btn"
                            *ngIf="isForRejection" (click)="rejectAssignment(legAssignmentForm)">Reject</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</mat-dialog-content>
